/* eslint-disable no-shadow,no-param-reassign */
import _ from "lodash";

const initialState = {
  id: false,
  name: "",
  kind: "",
  status: "",
  createdAt: null,
  publishedAt: null,
  showAddQuestion: false,
  pages: {},
  alternateEndings: {},
  pool: [],
  pageCount: 1,
  currentPage: 1,
  tags: [],
  list: {},
  startButtonIcon: "",
  startButtonText: "",
  scheduleMessage: "",
  openEdits: {},
  doctors: {},
  nextStepsHeader: "",
  nextSteps: "",
  nextStepsButtonLabel: "",
  nextStepsButtonUrl: "",
  nextButtonText: "",
  welcomeMessage: "",
  welcomeHeader: "",
  notificationEmailSubject: "",
  notificationEmailBody: "",
  notificationText: "",
  notificationReferrerSubject: "",
  notificationReferrerBody: "",
  notificationUsers: []
};

export const state = initialState;

export const getters = {
  pool: state => state.pool,
  poolGet: state => id => state.pool[id],
  poolByTag: state => tag =>
    _.filter(
      Object.values(state.pool),
      o => _.indexOf(o.attributes.tagList, tag) > -1
    ),
  tags: state => state.tags,
  list: state => state.list,
  openEditCount: state => Object.keys(state.openEdits).length,
  getById: state => id => state.list[id],
  doctors: state => state.doctors,
  getDoctor: state => id => state.doctors[id],
  currentPage: state => state.currentPage,
  pageCount: state => state.pageCount,
  getPage: state => id => state.pages[id],
  getAlternateEnding: state => id => state.alternateEndings[id]
};

export const actions = {
  set({ commit }, payload) {
    commit("set", payload);
  },

  reset({ commit }) {
    commit("reset", initialState);
  },

  updateQuestion({ commit }, payload) {
    commit("updateQuestion", payload);
  },

  addQuestion({ commit }, payload) {
    commit("addQuestion", payload);
  },

  toggleAddQuestion({ commit }, payload) {
    commit("toggleAddQuestion", payload);
  },

  removeQuestion({ commit }, payload) {
    commit("removeQuestion", payload);
  },

  setPool({ commit }, payload) {
    commit("setPool", payload.interviews);

    let currentPage = 1;
    let pageCount = 1;

    if (payload.links.self) {
      const current = payload.links.self.match(/page%5Bnumber%5D=(\d+)&/);
      currentPage = current[1];
    }

    if (payload.links.last) {
      const last = payload.links.last.match(/page%5Bnumber%5D=(\d+)&/);
      pageCount = last[1];
    } else {
      pageCount = currentPage;
    }

    state.pageCount = pageCount;
    state.currentPage = currentPage;
  },

  add({ commit }, payload) {
    commit("add", payload);
  },

  update({ commit }, payload) {
    commit("update", payload);
  },

  remove({ commit }, payload) {
    commit("remove", payload);
  },

  setTags({ commit }, payload) {
    commit("setTags", payload);
  },

  setList({ commit }, payload) {
    commit("setList", payload);
  },
  updateInterview({ commit }, payload) {
    commit("updateInterview", payload);
  },
  addOpenEdit({ commit }, payload) {
    commit("addOpenEdit", payload);
  },
  removeOpenEdit({ commit }, payload) {
    commit("removeOpenEdit", payload);
  },
  clearOpenEdit({ commit }) {
    commit("clearOpenEdit");
  },
  setDoctors({ commit }, payload) {
    commit("setDoctors", payload);
  },
  removeDoctor({ commit }, payload) {
    commit("removeDoctor", payload);
  },
  reinstateDoctor({ commit }, payload) {
    commit("reinstateDoctor", payload);
  }
};

export const mutations = {
  set(state, data) {
    const interview = Object.values(data.interviews)[0];
    state = Object.assign(
      state,
      { id: interview.id, ...interview.attributes },
      { pages: data.interviewPages || [] },
      { alternateEndings: data.interviewAlternateEndings || [] },
      { doctors: {} }
    );
  },

  reset(state, data) {
    const interview = data;
    state = Object.assign(
      state,
      { id: interview.id, ...interview.attributes },
      { pages: data.interviewPages },
      { alternateEndings: data.interviewAlternateEndings },
      { doctors: {} }
    );
  },

  updateQuestion(state, question) {
    const pageQuestions =
      state.pages[question.attributes.interviewPageId].attributes.questions;
    const index = _.findIndex(pageQuestions, ["id", question.id]);
    const pages = _.cloneDeep(state.pages);
    const id = question.id;
    pages[question.attributes.interviewPageId].attributes.questions[index] = {
      ...question.attributes,
      id
    };

    state.pages = pages;
  },

  addQuestion(state, question) {
    const pages = _.cloneDeep(state.pages);
    pages[question.attributes.interviewPageId].attributes.questions.push({
      ...question.attributes,
      id: question.id
    });

    state.pages = pages;
  },

  removeQuestion(state, question) {
    const pages = _.cloneDeep(state.pages);
    const index = _.findIndex(pages[question.pageId].attributes.questions, [
      "id",
      question.questionId
    ]);
    pages[question.pageId].attributes.questions.splice(index, 1);

    state.pages = pages;
  },

  toggleAddQuestion(state, show) {
    state.showAddQuestion = show;
  },

  setPool(state, data) {
    state.pool = data;
  },

  add(state, interview) {
    state.pool = Object.assign(state.pool, interview);
  },

  update(state, interview) {
    state.pool = Object.assign(state.pool, interview);
  },

  remove(state, interviewId) {
    const pool = _.cloneDeep(state.pool);
    state.pool = _.omitBy(pool, (value, key) => key === interviewId);

    const list = _.cloneDeep(state.list);
    state.list = _.omitBy(list, (value, key) => key === interviewId);
  },

  setTags(state, tags) {
    state.tags = tags;
  },
  setList(state, list) {
    state.list = list;
  },
  updateInterview(state, data) {
    _.forEach(Object.keys(data), key => {
      state[key] = data[key];
    });
  },
  addOpenEdit(state, id) {
    const openId = {};
    openId[id] = 1;
    state.openEdits = Object.assign({}, state.openEdits, openId);
  },
  removeOpenEdit(state, id) {
    const edits = _.cloneDeep(state.openEdits);
    state.openEdits = _.omitBy(edits, (value, key) => key === id);
  },
  clearOpenEdit(state) {
    state.openEdits = {};
  },
  setDoctors(state, doctors) {
    state.doctors = doctors;
  },
  removeDoctor(state, id) {
    const doctors = _.cloneDeep(state.doctors);
    doctors[id].attributes.deletedAt = true;
    state.doctors = doctors;
  },
  reinstateDoctor(state, id) {
    const doctors = _.cloneDeep(state.doctors);
    doctors[id].attributes.deletedAt = null;
    state.doctors = doctors;
  }
};
